/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const putApiProjectstatusesIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const putApiProjectstatusesId200Schema = z.any();

export const putApiProjectstatusesIdMutationRequestSchema = z.object({
  name: z.coerce.string(),
});

export const putApiProjectstatusesIdMutationResponseSchema = z.lazy(
  () => putApiProjectstatusesId200Schema,
);
